import { ProductsId } from '@webc/meeseeks-ui-sdk';

export const isHumanProduct: (product: ProductsId) => boolean = (product) =>
  product !== 'bike_slot' && product !== 'wheelchair';
